// src/config.js
export const API_BASE_URL = 
  (import.meta.env && import.meta.env.VITE_API_URL) || 
  "https://ambulancias-titan-api.onrender.com";